import React from "react";
import Input from "components/Input";
import TextArea from "components/TextArea";
import {
  Container,
  Divider,
  Header,
  Title,
  ActionRow,
  ActionButton,
  FieldGrid,
  InputGroup,
  Label,
} from "./styles";

function FormStepEditor({
  step,
  index,
  onChange,
  onMoveUp,
  onMoveDown,
  onDelete,
  onAddField,
  addFieldDisabled,
  addFieldTooltip,
  children,
}) {
  return (
    <Container>
      <Header>
        <Title>{step.title || `Etapa ${index + 1}`}</Title>
        <ActionRow>
          <ActionButton onClick={onMoveUp} disabled={index === 0}>
            ↑ Subir
          </ActionButton>
          <ActionButton onClick={onMoveDown}>↓ Descer</ActionButton>
          <ActionButton
            onClick={onAddField}
            disabled={addFieldDisabled}
            title={addFieldTooltip || ""}
          >
            Adicionar Campo
          </ActionButton>
          <ActionButton onClick={onDelete}>Excluir Etapa</ActionButton>
        </ActionRow>
      </Header>

      <FieldGrid>
        <InputGroup>
          <Label>Título</Label>
          <Input
            value={step.title}
            onChange={(e) => onChange({ ...step, title: e.target.value })}
            placeholder="Título da etapa"
          />
        </InputGroup>
        <InputGroup>
          <Label>Identificador</Label>
          <Input value={step.id} disabled />
        </InputGroup>
      </FieldGrid>

      <InputGroup style={{ marginTop: 16 }}>
        <Label>Descrição</Label>
        <TextArea
          value={step.description}
          onChange={(e) => onChange({ ...step, description: e.target.value })}
          placeholder="Descrição opcional da etapa"
        />
      </InputGroup>

      {children && (
        <>
          <Divider />
          {children}
        </>
      )}
    </Container>
  );
}

export default FormStepEditor;
